<vi-tabs [tabs]="tabs" (select)="onTabChange($event)"></vi-tabs>
<div class="scheme-container flex flex-col justify-center items-center">
  <vi-content *ngIf="hydraulicSchematicStore.hydraulicSchemeLoading$ | async; else loaded">
    <vi-loader
      main
      data-at-loader
      message="{{ '+INSTALLATIONS.INSTALLATION.HYDRAULIC_SCHEMATIC.LOADING_MESSAGE' | translate }}"
      [isLoading]="true"
    ></vi-loader>
  </vi-content>
  <ng-template #loaded>
    <ng-container
      *ngIf="svg && !(hydraulicSchematicStore.isHydraulicSchematicError$ | async); else missingSvg"
    >
      <div class="full-width flex flex-row justify-end items-end">
        <button
          class="download-pdf-btn"
          data-at-download-scheme-pdf
          mat-raised-button
          gtm="onDownload"
          gtmAction="Hydraulic schematic pdf download"
          gtmCategory="hydraulicSchematic"
          color="primary"
          mat-button
          (click)="saveAsPdf()"
        >
          <mat-icon>download</mat-icon>
          <span>{{ 'GENERAL.BUTTON.SAVE_AS_PDF' | translate }}</span>
        </button>
      </div>

      <div class="svg-container" [innerHTML]="svg"></div>

      <div class="full-width flex flex-row justify-end items-end">
        <button
          class="download-pdf-btn"
          data-at-download-scheme-pdf
          mat-raised-button
          gtm="onDownload"
          gtmAction="Hydraulic schematic pdf download"
          gtmCategory="hydraulicSchematic"
          color="primary"
          mat-button
          (click)="saveAsPdf()"
        >
          <mat-icon>download</mat-icon>
          <span>{{ 'GENERAL.BUTTON.SAVE_AS_PDF' | translate }}</span>
        </button>
      </div>

      <vi-loader
        data-at-loader
        *ngIf="isAnyFromHydraulicSchematicVddLoading"
        [isLoading]="true"
      ></vi-loader>

      <app-hydraulic-schematic-vdd-table
        class="full-width"
        data-at-vdd-table
        *ngIf="showTable"
      ></app-hydraulic-schematic-vdd-table>
    </ng-container>

    <ng-template #missingSvg>
      <vi-alert data-at-alert-no-hydraulic-scheme>
        {{ '+INSTALLATIONS.INSTALLATION.HYDRAULIC_SCHEMATIC.ERROR' | translate }}
      </vi-alert>
    </ng-template>
  </ng-template>
</div>
